import { type ReactNode } from 'react';

import { type PublicShowcaseLayoutBlockRenderProps } from '~/providers/PublicShowcaseProvider';

/**
 * The viewer surfaces' block renderer (the live /a page and the Preview iframe): a hidden block
 * renders NOTHING — viewers never see it, not even a placeholder — while the editor's Edit-tab
 * counterpart shows every block inside its edit shell so authors can restore hidden ones.
 */
export const renderPublicShowcaseBlock = ({ block, children }: PublicShowcaseLayoutBlockRenderProps): ReactNode =>
  block.hidden ? null : children;
